import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MessageDisplay from './components/MessageDisplay';
// Importar las páginas principales
import AdminPage from './pages/admin/AdminPage';
import UserModerationPage from './pages/admin/UserModerationPage';
import RevisionPreguntasPage from './pages/admin/RevisionPreguntasPage';
import ModificarPreguntaModalPage from './pages/admin/ModificarPreguntaModalPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import UserProfilePage from './pages/user/UserProfilePage';
import MisPreguntasPage from './pages/user/MisPreguntasPage';
import PremiosUsuarioPage from './pages/user/PremiosUsuarioPage';
import QuizPage from './pages/quiz/QuizPage';
import OBSViewPage from './pages/quiz/OBSViewPage';
import FormularioComunidadPage from './pages/quiz/FormularioComunidadPage';
import FormularioDirectoPage from './pages/quiz/FormularioDirectoPage';
import ConcursoPreviewPage from './pages/quiz/ConcursoPreviewPage';
import InicioConcursoPage from './pages/quiz/InicioConcursoPage';
import { BrowserRouter as Router, Routes, Route, unstable_viewTransition } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext'; // Importar el UserProvider
import { MessageProvider } from './contexts/MessageContext'; // Importar el MessageProvider
import { ModerationProvider } from './contexts/ModerationContext'; // Importar el ModerationProvider
import './components/formStyles.css';
import SidebarTransition from './components/SidebarTransition';
import SidebarTransitionWrapper from './components/SidebarTransitionWrapper';
import { SidebarTabProvider } from './contexts/SidebarTabContext';
import { PwaInstallProvider } from './contexts/PwaInstallContext';

import { useState, useCallback } from 'react';

function App() {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  // Callback para recibir el estado del sidebar desde SidebarTransition
  const handleSidebarVisible = useCallback((visible) => {
    setSidebarVisible(visible);
  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider>
        <UserProvider>
          <MessageProvider>
            <ModerationProvider>
              <SidebarTabProvider>
              <PwaInstallProvider>
                {/* Fondo global animado (aurora) — se mueve siempre y cambia con el tema */}
                <div className="app-aurora" aria-hidden="true">
                  <div className="app-aurora-grid" />
                  <div className="app-aurora-orb app-aurora-orb-1" />
                  <div className="app-aurora-orb app-aurora-orb-2" />
                  <div className="app-aurora-orb app-aurora-orb-3" />
                </div>
                <Header />
                <div className="min-h-[calc(100dvh-4rem)] flex transition-colors duration-300 overflow-x-hidden">
                  {/* Pasar el callback para saber si el sidebar está visible */}
                  <SidebarTransitionWrapper onSidebarVisible={handleSidebarVisible} />
                  <div className="flex-1 flex flex-col">
                    <main className={`flex-1 transition-all duration-300 overflow-x-hidden ${sidebarVisible ? 'lg:pl-56' : 'pl-0'}`}>
                      <MessageDisplay />
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route element={<RequireAuth />}>
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/admin/moderacion" element={<UserModerationPage />} />
                        <Route path="/admin/revision" element={<RevisionPreguntasPage />} />
                        <Route path="/admin/modificar-pregunta" element={<ModificarPreguntaModalPage />} />
                        <Route path="/user/profile" element={<UserProfilePage />} />
                        <Route path="/user/mis-preguntas" element={<MisPreguntasPage />} />
                        <Route path="/user/premios" element={<PremiosUsuarioPage />} />
                      </Route>
                      <Route path="/quiz" element={<QuizPage />} />
                      <Route path="/quiz/obs-view" element={<OBSViewPage />} />
                      <Route path="/quiz/formulario-comunidad" element={<FormularioComunidadPage />} />
                      <Route path="/quiz/formulario-directo" element={<FormularioDirectoPage />} />
                      <Route path="/quiz/preview" element={<ConcursoPreviewPage />} />
                      <Route path="/quiz/inicio" element={<InicioConcursoPage />} />
                    </Routes>
                  </main>
                </div>
              </div>
              </PwaInstallProvider>
            </SidebarTabProvider>
            </ModerationProvider>
          </MessageProvider>
        </UserProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
